export function initUnitzoeker() {

    // Initialize units for a specific view
    function initUnitsForView(viewType) {
        const svgId = viewType === 'voor' ? '#units-svg-front' : '#units-svg-back';
        const svg = jQuery(svgId);
        
        if (!svg.length) {
            return;
        }

        // Remove all status classes from polygons in this SVG
        svg.find('polygon').removeClass('vrij verkocht in-optie later');

        // Iterate through each unit detail element
        jQuery('.all-unit-details .unit-details').each(function() {
            const unitNumber = jQuery(this).data('unit');
            const status = jQuery(this).data('status');
            const polygon = svg.find('polygon[data-name="' + unitNumber + '"]');

            if (polygon.length) {
                switch (status) {
                case 'Vrij':
                    jQuery(polygon).addClass('vrij');
                    break;
                case 'BESCHIKBAAR':
                    jQuery(polygon).addClass('vrij');
                    break;
                case 'VERKOCHT_ONDER_VOORBEHOUD':
                    jQuery(polygon).addClass('verkocht');
                    break;
                case 'Verkocht':
                    jQuery(polygon).addClass('verkocht');
                    break;
                case 'ONDER_OPTIE':
                    jQuery(polygon).addClass('in-optie');
                    break;
                case 'In optie':
                    jQuery(polygon).addClass('in-optie');
                    break;
                case 'Later':
                    jQuery(polygon).addClass('later');
                    break;
                default: 
                    jQuery(polygon).addClass('later');
                    break;
                }
            }
        });
    }

    // Setup click handlers for polygons in active SVG
    function setupPolygonClickHandlers(viewType) {
        const svgId = viewType === 'voor' ? '#units-svg-front' : '#units-svg-back';

        // Remove existing handlers to prevent duplicates
        jQuery(svgId + ' polygon').off('click.unitzoeker');

        // Add click handler
        jQuery(svgId + ' polygon').on('click.unitzoeker', function() {
            const polygonId = jQuery(this).attr('data-name');
            jQuery('.unit-details').removeClass('active-unit');
            jQuery('.unit-details[data-unit="' + polygonId + '"]').addClass('active-unit');
        });
    }

    // Get active view
    function getActiveView() {
        const activeWrapper = jQuery('.overview-wrapper:not(.hidden)').first();
        return activeWrapper.length ? activeWrapper.data('view') : 'voor';
    }

    // Initialize for active view on page load
    const activeView = getActiveView();
    initUnitsForView(activeView);
    setupPolygonClickHandlers(activeView);

    // Tab switching functionality
    jQuery('.unitzoeker-tab').on('click', function() {
        const viewType = jQuery(this).data('view');
        // eslint-disable-next-line no-unused-vars
        const viewIndex = jQuery(this).data('view-index');

        // Update active tab
        jQuery('.unitzoeker-tab').removeClass('active');
        jQuery(this).addClass('active');

        // Hide all overview wrappers
        jQuery('.overview-wrapper').addClass('hidden');

        // Show selected view
        jQuery('.overview-wrapper[data-view="' + viewType + '"]').removeClass('hidden');

        // Re-initialize units for the new view
        initUnitsForView(viewType);
        setupPolygonClickHandlers(viewType);
    });

    // Close Details on click on Overlay
    jQuery('.info-overlay').on('click', function() {
        jQuery('.unit-details').removeClass('active-unit');
    });

}